// extracted by mini-css-extract-plugin
export default {"container":"Matches-Album_container__C94T0","emptyContainer":"Matches-Album_emptyContainer__EPLbi"};